import React, { Component } from 'react'
import { Row, Col } from 'react-bootstrap'
import '../styles/storyStyle.css'
import StartBtn from './StartBtn'

export default class StoryContent extends Component {
  render () {
    const storyTextStyle = {
      backgroundColor: 'white',
      padding: 30,
      zIndex: 10
    }

    const btnStyle = {
      height: '100%',
      width: '100%',
      maxHeight: 197,
      maxWidth: 301,
      position: 'relative',
      marginTop: -40,
      zIndex: 50
    }
    const storyWrapper = {
      width: '100%',
      top: 50,
      position: 'relative',
      zIndex: 0
    }

    return (
      <div style={storyWrapper}>
        <Col xs={0} sm={1} />
        <Col xs={12} sm={10} md={8} lg={6}>
          <div className='box effect8'>
            <div style={storyTextStyle}>
              <p>
                Retirement planning is complex and for many people,
                demoralizing. It is complex because like a mechanical clock
                there are many moving parts. It can also be demoralizing because
                often success boils down to saving money.
              </p>
              <p>
                But let’s set the “saving money” part aside for now. Instead
                let’s focus on the clock. Clocks are complicated but the gears,
                springs and wheels that make them tick are not. These are simple
                components that are easy to understand in isolation. It turns
                out that the individual elements that make up retirement are
                also fairly simple. It is the building of the individual
                elements into a working clock that can be confounding.
              </p>
              <p>
                But I believe that with the right tools anyone with a high
                school education can successfully put together and execute a
                retirement plan that will satisfy their fundamental desires for
                many years. I challenge you to find out if I’ve provided those
                tools here, today!
              </p>
            </div>
          </div>
        </Col>
        <Col xs={0} sm={1} md={3} lg={5} />

        <Row>
          <Col xs={6} lg={6} />
          <Col xs={6} sm={5} md={3} lg={4}>
            <StartBtn btnStyle={btnStyle} />
          </Col>
          <Col xs={0} sm={1} md={3} lg={4} />
        </Row>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/landing-elements/StoryContent.js